import { render } from "./StoreCollectionFixed.vue?vue&type=template&id=6b170cb9&scoped=true"
import script from "./StoreCollectionFixed.vue?vue&type=script&lang=js"
export * from "./StoreCollectionFixed.vue?vue&type=script&lang=js"

import "./StoreCollectionFixed.vue?vue&type=style&index=0&id=6b170cb9&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b170cb9"]])

export default __exports__